const StorageKeys = {
  userSessionInfo: 'USER_SESSION_INFO_KEY',
};

export default StorageKeys;
